import { GeeksApi, GuidesApi } from '@/api';
import { ActionIds, Guide, GuideStep } from '@/models/guides';
import { Module } from 'vuex';
import { Actions } from './actions';
import { Mutations } from './mutations';
import { RootState } from './root.store';
import { Geek, GeekItem, Empty } from '@/models';

const guidesApi = new GuidesApi();
const geeksApi = new GeeksApi();

export interface GuidesState {
  allGuides: Guide[];
  guideSteps: GuideStep[];
  guideMaster: GeekItem;
  guideUser: GeekItem;
}

export const GuidesModule: Module<GuidesState, RootState> = {
  state: {
    allGuides: [],
    guideSteps: [],
    guideMaster: Empty.geekItem,
    guideUser: Empty.geekItem,
  },

  mutations: {
    [Mutations.guides.setAllGuides](state, allGuides: Guide[]): void {
      state.allGuides = allGuides;
    },
    [Mutations.guides.setGuideSteps](state, guideSteps: GuideStep[]): void {
      state.guideSteps = guideSteps;
    },
    [Mutations.guides.setGuideMasterBasicInfo](state, guideMaster: GeekItem): void {
      state.guideMaster = guideMaster;
    },
    [Mutations.guides.setGuideUserBasicInfo](state, guideUser: GeekItem): void {
      state.guideUser = guideUser;
    },
  },

  actions: {
    async [Actions.guides.fetchAllGuides]({ commit }): Promise<void> {
      const allGuides = await guidesApi.fetchAllGuides();
      commit(Mutations.guides.setAllGuides, allGuides);
    },
    async [Actions.guides.fetchGuideSteps]({ commit }, guideId: string): Promise<void> {
      const guideSteps = await guidesApi.fetchGuideSteps(guideId);
      commit(Mutations.guides.setGuideSteps, guideSteps);
    },
    async [Actions.guides.markStepAsFinished](_, actionIds: ActionIds): Promise<void> {
      await guidesApi.markStepAsFinished(actionIds);
    },
    async [Actions.guides.fetchGuideMasterBasicInfo]({ commit }, geekId: string): Promise<void> {
      const guideMaster = await geeksApi.fetchGeekBasicInfo(geekId);
      commit(Mutations.guides.setGuideMasterBasicInfo, guideMaster);
    },
    async [Actions.guides.fetchGuideUserBasicInfo]({ commit }): Promise<GeekItem> {
      const guideUser = await geeksApi.fetchGeekBasicInfo();
      commit(Mutations.guides.setGuideUserBasicInfo, guideUser);
      return Promise.resolve(guideUser);
    },
  },
};
